import 'lazysizes';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';

import './Presentation/Atom/TelephoneLink/TelephoneLink';
import './Presentation/Atom/RichText/RichText';
import './Presentation/Atom/Video/Video';
import './Presentation/Atom/Dropdown/Dropdown';
import './Presentation/Atom/LocationOpeningStatus/LocationOpeningStatus';

import './Presentation/Molecule/Ap24WebWidget/Ap24WebWidget';
import './Presentation/Molecule/CookieConsent/CookieConsent';
import './Presentation/Molecule/YoutubePlayer/YoutubePlayer';
import './Presentation/Molecule/Slider/Slider';
import './Presentation/Molecule/ImageGallery/ImageGallery';

import './Presentation/Organism/Header/Header';
import './Presentation/Organism/SearchPopup/SearchPopup';
import './Presentation/Organism/ServiceBooking/ServiceBooking';
import './Presentation/Organism/TableAccordion/TableAccordion';

// Stripe Payment form from CodeQ.StripePayment package
import '../../../../CodeQ.StripePayment/Resources/Private/JavaScript/PaymentForm';

Alpine.plugin(focus);
Alpine.plugin(collapse);

// We use this to enable the AlpineJS debugger in the browser.
if (!document.documentElement.dataset.debug) {
    window.Alpine = Alpine;
}

// Safari 11 polyfill for AlpineJS, see also https://github.com/alpinejs/alpine/discussions/1964
if (typeof window.queueMicrotask !== 'function') {
    window.queueMicrotask = function (callback) {
        Promise.resolve()
            .then(callback)
            .catch((e) =>
                setTimeout(() => {
                    throw e;
                })
            );
    };
}

Alpine.start();
